import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Component, input, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'iot-platform-ui-drag-drop-indicator',
  imports: [CdkDragHandle, MatIcon],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template>
      <mat-icon cdkDragHandle class="dd-handle-icon">{{ icon() }}</mat-icon>
      <ng-content />
    </ng-template>
  `
})
export class DragDropIndicatorComponent {
  icon = input<string>('drag_indicator');
  @ViewChild(TemplateRef, { static: true }) public template!: TemplateRef<unknown>;
}
